export const baseUrl = process.env.VUE_APP_API_BASE_URL || "/api";
export const httpTimeout = 300 * 1000;
export const PC_PLATFORM_ID = "3463b3faf7022a627f7a4cdaaa90a6ce";

export const captcha4Generate = baseUrl + "/common/captcha/generate";
export const captcha4Check = baseUrl + "/common/captcha/check";

export default {

}
